import { AnimatePresence, motion } from 'framer-motion';

//STYLE
import { ContainerAnalises } from './styled';

//APP
import { dinheiro } from '../../../../../../../../../../utils';
import { useFormOsContext } from '../../context/FormOsContext';

//COMPONENTS
import Carregando from '../../../../../../../../../../Components/CustomUi/loading';
import { Box } from '../../../../../../../../../../Components/CustomUi/box';
import { LineDivider } from '../../../../../../../../../../Components/CustomUi/LineDivider';
import { ListaAnalises } from './components/lista';
import { HeaderAnalises } from './components/header';


/** Metade direita do formulário de OS: análises da malha amostral. */
export function Analises() {
    const {
        analises: {
            carregando_grupo_analises,
            loadingShape,
            total_amostras,
            grid_amostral,
            rs_por_ha,
            valor_total,
        },
    } = useFormOsContext();

    const mostrarOverlay = carregando_grupo_analises || loadingShape
    const legendaOverlay = loadingShape
        ? 'Processando malha...'
        : 'Buscando análises do laboratório...'

    return (
        <ContainerAnalises>
            <Box gap={10} style={{ width: '100%' }} padding={15}>
                <h3>Análises</h3>
                <HeaderAnalises />
                <LineDivider />
                <ListaAnalises />
            </Box>

            <div className='footer__analises'>
                <div className='detalhes'>
                    <span style={{ color: '#7B7B7B', fontSize: 13, fontWeight: 500 }}>Total de amostras</span>
                    <strong>{total_amostras}</strong>
                </div>
                <div className='detalhes'>
                    <span style={{ color: '#7B7B7B', fontSize: 13, fontWeight: 500 }}>Grid Amostral</span>
                    <strong>{grid_amostral} ha/pontos</strong>
                </div>
                <div className='detalhes'>
                    <span style={{ color: '#7B7B7B', fontSize: 13, fontWeight: 500 }}>R$ por ha</span>
                    <strong>{dinheiro(rs_por_ha)}</strong>
                </div>
                <div className='detalhes' data-active={true}>
                    <span>Valor total</span>
                    <strong>{dinheiro(valor_total)}</strong>
                </div>
            </div>

            <AnimatePresence>
                {mostrarOverlay && (
                    <motion.div
                        className='overlay_loading_lab'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <Carregando animation legenda={legendaOverlay} justifyContent='center' />
                    </motion.div>
                )}
            </AnimatePresence>
        </ContainerAnalises>
    )
}
